/*
 * Author: zoesvision.com
 * Purpose: Apply the configured initial disclosure state to the isolated z-faq section.
 */

class ZFaq extends HTMLElement {
  connectedCallback() {
    const items = [...this.querySelectorAll('[data-z-faq-item]')];
    const initialState = this.dataset.zInitialState;
    const singleOpen = this.dataset.zSingleOpen === 'true';

    items.forEach((item) => item.removeAttribute('open'));

    if (initialState === 'all_open' && !singleOpen) {
      items.forEach((item) => item.setAttribute('open', ''));
    } else if (initialState === 'first_open' || (initialState === 'all_open' && singleOpen)) {
      items[0]?.setAttribute('open', '');
    }
  }
}

if (!customElements.get('z-faq')) {
  customElements.define('z-faq', ZFaq);
}
